import { Controller } from '@hotwired/stimulus';

/**
 * reply-composer — manages the quoted-reply banner of the phase discussion.
 *
 * The hidden `parentField` carries the parent DiscussionMessage id (the server
 * wires the reply); the banner author/snippet are display-only. So `startReply`
 * writes the numeric `id` into the field while still showing author/snippet in
 * the banner; `cancelReply` clears the field back to a root message.
 *
 * Targets: banner, bannerAuthor, bannerSnippet, parentField
 * Actions:
 *   startReply  (from a message's "Répondre")  — params: id, author, snippet
 *   cancelReply (from the banner ✕)
 */
export default class extends Controller {
  static targets = ['banner', 'bannerAuthor', 'bannerSnippet', 'parentField'];

  startReply(event) {
    const { id, author, snippet } = event.params;
    this.bannerAuthorTarget.textContent = author || '';
    this.bannerSnippetTarget.textContent = snippet || '';
    if (this.hasParentFieldTarget) this.parentFieldTarget.value = id ?? '';
    this.bannerTarget.classList.remove('hidden');
    this.bannerTarget.classList.add('flex');
    this.element.querySelector('textarea')?.focus();
  }

  cancelReply() {
    if (this.hasParentFieldTarget) this.parentFieldTarget.value = '';
    this.bannerTarget.classList.add('hidden');
    this.bannerTarget.classList.remove('flex');
  }
}
